module.exports = __webpack_public_path__ + "img/profile_delphinus@2x.2552fd63.png";